<template>
	<div class="box">
		<div class="logo">
			<img src="../assets/image/logo.png" alt=""  v-show="logoBool" />
		</div>
		<div class="ipt">
			<input type="text" name="" id="" value="" v-model="iptValue" placeholder="哪里不舒服或想了解牙科知识，请输入"/>
			<div class="btn" @click="searchFn">
			</div>
		</div>
		
		<div class="textBox">
			<p>大家都在搜</p>
			<div class="content">
				<span v-for="item in dzsdata" @click="searchspanFn(item)">{{item}}</span>
			</div>
		</div>
		<!--<div class="textBox">
			<p>搜索历史</p>
			<div class="content">
				<span v-for="item in dzsdata">{{item}}</span>
			</div>
			<div class="clear">
				<img src="../assets/image/clear.png"/>
				<span>清除历史记录</span>
			</div>
		</div>-->
	</div>
</template>
<script>
	import { mapState ,mapMutations} from 'vuex'

	export default{
		
		data(){
			return{
				dzsdata:['牙齿矫正','牙疼','智齿','蛀牙','口臭','牙龈出血','牙结石','牙齿美白'],
				iptValue:'',
				logoBool:true
			}
		},
		created(){
			this.changeUser({wno:this.$route.query.wno});
			if(this.$route.query.wno=='10bd833a-8de7-4c38-89ba-fdbd420d4a8d'){
				this.logoBool=true;
			}else{
				this.logoBool=false;
			}
		},
		methods:{
			...mapMutations(['changeUser']),
			searchFn(){
				this.$router.push({
					name:'search',
					query:{
						val:this.iptValue,
						wno:this.$store.state.wno
					}
				})
			},
			searchspanFn(val){
				this.$router.push({
					name:'search',
					query:{
						val:val,
						wno:this.$store.state.wno
					}
				})
			}
		}
	}
</script>

<style scoped>
	.box{
		width: 100%;

	}
	.logo{
		height: 337px;
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: flex-end;
	}
	.logo>img{
		width:174px;
		height:142px;
		margin-bottom: 50px;
	}
	.ipt{
		height: 90px;
		width: 100%;
		display: flex;
		justify-content: center;
		position: relative;
	}
	.ipt>input{
		width: 100%;
		height: 80px;
		margin: 0 50px;
		padding-left: 20px;
		background:rgba(255,255,255,1);
		box-shadow:0px 0px 10px 5px rgba(245,245,245,0.4),0px 0px 2px 1px rgba(218,218,218,0.23);
		border-radius:16px;
		border:1px solid rgba(151,151,151,.4);
		outline: none;
	}
	.btn{
		width:74px;
		height:74px;
		background:rgba(29,181,255,1);
		border-radius:14px;
		background: url(../assets/image/sousuo.png) no-repeat center center;
		background-size:100% ;
		position: absolute;
		top: 3px;
		right: 55px;
	}
	.textBox{
		margin: 0 50px;
		margin-top: 100px;
		position: relative;
	}
	.textBox>p{
		font-size:28px;
		font-family:PingFangSC-Regular,PingFang SC;
		font-weight:400;
		color:rgba(74,74,74,1);
		line-height:30px;
	}
	.content{
		margin-top: 40px;
		overflow: hidden;
		display: flex;
		justify-content: space-around;
		flex-wrap:wrap;
		
	}
	.content>span{
		display: inline-block;
		float: left;
		text-align: center;
		width:150px;
		height:60px;
		background:rgba(242,247,250,1);
		border-radius:30px;
		font-size:26px;
		font-family:PingFangSC-Regular,PingFang SC;
		font-weight:400;
		color:rgba(155,155,155,1);
		line-height:60px;
		/*margin-right: 10px;*/
		margin-bottom: 15px;
		cursor: pointer;
	}
	.clear>img{
		width:30px;
		height:30px;
	}
	.clear>span{
		font-size:24px;
		font-family:PingFangSC-Regular,PingFang SC;
		font-weight:400;
		color:rgba(155,155,155,1);
		line-height:30px;
		margin-left: 10px;
	}
	.clear{
		position: absolute;
		top: 0;
		right: 0;
		display: flex;
	}
</style>


// WEBPACK FOOTER //
// src/components/index.vue